/* Custom Badge System (CBS) - PDP live badge swap. No-op on non-product pages. */
(function () {
  'use strict';

  function init() {
    var dataEl = document.getElementById('cbs-variant-data');
    if (!dataEl) return; // Not a PDP, or no badge data - nothing to do.

    var data;
    try {
      data = JSON.parse(dataEl.textContent || '{}');
    } catch (e) {
      data = {};
    }

    var section =
      dataEl.closest('section') ||
      dataEl.closest('.shopify-section') ||
      document;

    function findLayerHost() {
      // Anchor to the CURRENTLY ACTIVE media slide first. Variants can each have
      // their own image, so the visible slide changes on variant switch. Pinning
      // to the first slide would strand the badge on a hidden slide.
      return (
        section.querySelector('.product__media-item.is-active') ||
        section.querySelector('.product__media-list .is-active') ||
        section.querySelector('.product__media-item') ||
        section.querySelector('.product__media-list') ||
        section.querySelector('.product__media-wrapper') ||
        section.querySelector('media-gallery') ||
        null
      );
    }

    function getCurrentVariantId() {
      try {
        var url = new URL(window.location.href);
        var v = url.searchParams.get('variant');
        if (v) return String(v);
      } catch (e) {}
      var input =
        section.querySelector('form[action*="/cart/add"] [name="id"]') ||
        section.querySelector('[name="id"]');
      if (input && input.value) return String(input.value);
      return null;
    }

    function render(variantId, host) {
      host = host || findLayerHost();
      if (!host) return;

      var serverLayer = section.querySelector('[data-cbs-layer]');
      var badge = variantId ? data[variantId] : null;

      if (!badge) {
        if (serverLayer) serverLayer.remove();
        return;
      }

      var pos = badge.position || 'top-left';
      var layer = serverLayer;
      if (!layer) {
        layer = document.createElement('div');
        layer.setAttribute('data-cbs-layer', '');
      }
      // Re-home the layer onto the active slide every render.
      if (layer.parentNode !== host) host.appendChild(layer);

      layer.className = 'cbs-badge-layer cbs-pos-' + pos;

      var span = layer.querySelector('.cbs-badge');
      if (!span) {
        span = document.createElement('span');
        span.className = 'cbs-badge';
        layer.appendChild(span);
      }
      span.style.backgroundColor = badge.bg || '';
      span.style.color = badge.txt || '';
      span.style.borderRadius = badge.radius || '';
      span.style.padding = badge.pad || '';
      span.style.fontSize = badge.fontSize || '';
      span.textContent = badge.label || '';
    }

    var lastId;
    var lastHost;
    var firstRun = true;
    function refresh() {
      var id = getCurrentVariantId();
      var host = findLayerHost();
      if (!firstRun && id === lastId && host === lastHost) return;
      firstRun = false;
      lastId = id;
      lastHost = host;
      render(id, host);
    }

    refresh();

    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) {
      var evt =
        window.PUB_SUB_EVENTS.variantChange ||
        window.PUB_SUB_EVENTS.optionValueSelectionChange;
      if (evt) {
        window.subscribe(evt, function () {
          window.setTimeout(refresh, 0);
        });
      }
    }

    // Catch variant-picker changes anywhere in this section.
    document.addEventListener('change', function (e) {
      if (section === document || section.contains(e.target)) {
        window.setTimeout(refresh, 0);
      }
    });

    // Polling backstop: robust across theme versions. Re-renders on variant OR
    // active-slide change.
    window.setInterval(refresh, 400);

    window.addEventListener('popstate', function () {
      window.setTimeout(refresh, 0);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
